export default "__VITE_ASSET___RctFnGT__"